import React, {Component} from 'react'

import Tooltip from '@material-ui/core/Tooltip'
import Button from '@material-ui/core/Button'

import CreateFolderIcon from '@material-ui/icons/CreateNewFolder'
import CreateItemIcon from '@material-ui/icons/Add'
import EditItemIcon from '@material-ui/icons/Ballot'
import DeleteItemIcon from '@material-ui/icons/DeleteForever'
import MoveToFolderIcon from '@material-ui/icons/LowPriority'

import PaperBlock from "../../ui/PaperBlock"

/**
 * 	<ControlPanel
 * 		selected
 * 		onCreateFolderClick = {}
 * 		onCreateItemClick = {}
 * 		onMoveToFolderClick = {item}
 * 		onEditItemClick = {item}
 * 		onDeleteItemClick = {item}
 * 	/>
 */

class ControlPanel extends Component {

	render() {

		return <PaperBlock style = {{display: "flex"}}>

			<Tooltip title = "Создать папку"><div>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCreateFolderClick === "function") {
							this.props.onCreateFolderClick()
						}
					}}
				>
					<CreateFolderIcon />
				</Button>
			</div></Tooltip>


			<Tooltip title = "Создать предмет"><div>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCreateItemClick === "function") {
							this.props.onCreateItemClick()
						}
					}}
				>
					<CreateItemIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title = "Переместить в папку"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onMoveToFolderClick === "function") {
							this.props.onMoveToFolderClick(this.props.selected)
						}
					}}
				>
					<MoveToFolderIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title = "Редактировать"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onEditItemClick === "function") {
							this.props.onEditItemClick(this.props.selected)
						}
					}}
				>
					<EditItemIcon />
					</Button>
			</div></Tooltip>

			<Tooltip title = "Удалить"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onDeleteItemClick === "function") {
							this.props.onDeleteItemClick(this.props.selected)
						}
					}}
				>
					<DeleteItemIcon />
				</Button>
			</div></Tooltip>

		</PaperBlock>

	}

}

export default ControlPanel
